"use client";

// ============================================================
// CLUBHUB – Auswahllisten der Mitglieder-Formulare
// ============================================================
// Beitragsarten und Gruppen fuer Formulare und Dialoge, die tief im
// Baum sitzen. Das Layout von /mitglieder fuellt den Kontext aus
// `ladeBestand()` (Musterbestand oder echter Verein); ausserhalb davon
// gilt der Musterbestand, wie bisher.
// ============================================================
import { createContext, useContext } from "react";
import { MOCK_FEE_TYPES, MOCK_GROUPS } from "@/lib/mock/core";
import type { FeeTypeView, GroupView } from "@/lib/views";

export type MitgliederAuswahlWerte = { beitragsarten: FeeTypeView[]; gruppen: GroupView[] };

const Kontext = createContext<MitgliederAuswahlWerte>({ beitragsarten: MOCK_FEE_TYPES, gruppen: MOCK_GROUPS });

export function MitgliederAuswahl({ werte, children }: { werte: MitgliederAuswahlWerte; children: React.ReactNode }) {
  return <Kontext.Provider value={werte}>{children}</Kontext.Provider>;
}

export function useMitgliederAuswahl(): MitgliederAuswahlWerte {
  return useContext(Kontext);
}
